module.exports = __webpack_public_path__ + "static/media/wirebit_transfer.b9de42d4.svg";